import Forage from 'forage-js-sdk';

import { createForageToken } from 'api/jalapeno';
import { getIsProduction } from 'utils';

export const SANDBOX_MERCHANT_ID = '4ab7a062c2';
export const PRODUCTION_MERCHANT_ID = 'aaf8ee7ad1';

const getMerchantId = () => {
    const isProduction = getIsProduction();
    return isProduction ? PRODUCTION_MERCHANT_ID : SANDBOX_MERCHANT_ID;
};

/**
 * Initializes Forage SDK with customer ID.
 *
 * @param {Object} params
 * @param {string} params.customerID - Customer ID to initialize with
 * @returns {Promise<Object>} Forage SDK instance
 * @throws {Error} When customerID missing or API fails
 */
export const initForage = async ({ customerID }) => {
    const response = await createForageToken(customerID);
    const sessionToken = response?.data?.forageToken?.token;

    const merchantId = getMerchantId();

    if (!sessionToken) {
        throw new Error('Failed to get session token');
    }

    const forage = Forage({
        merchantId,
        sessionToken,
        customerId: window.btoa(customerID),
        appearance: {
            variables: {
                borderRadius: '4px',
                padding: '10px 20px',
                borderColor: '#000',
                borderWidth: '1px',
                textAlign: 'left',
                fontSizeBase: '16px',
            },
        },
    });

    return forage;
};
